import { Box, Tooltip } from "@chakra-ui/react";
import React from "react";
import { MdOpenInNew } from "react-icons/md";

import { LeverIcon } from "..";
import { Link } from "../Link";

const LeverLink: React.FC<{
  leverInterviewLink: string;
  leverText: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}> = ({ leverInterviewLink, leverText, onClick }) => {
  return (
    <Tooltip label={`Lever ${leverText}`} openDelay={500} placement="top">
      <Link
        href={leverInterviewLink}
        display="flex"
        alignItems="center"
        target="_blank"
        onClick={onClick}
      >
        <LeverIcon />
        <Box fontWeight="normal" mr="1">
          {leverText}
        </Box>
        <MdOpenInNew />
      </Link>
    </Tooltip>
  );
};

export default LeverLink;
